module.exports = __webpack_public_path__ + "img/picto-retargeting.6757eaab.svg";